import * as yup from 'yup';
import { isBelowLength } from '@shared/lib/validators';
import { phoneNumberSchema } from '../../../lib/phoneValidation';

export const MemberSchema = yup.object().shape({
  phoneNumber: phoneNumberSchema({ required: false }),
  firstName: yup.string().required('Vennligst fyll inn dette feltet.'),
  lastName: yup
    .string()
    .test('Lengde', 'Må være kortere enn 50 tegn', isBelowLength(50))
    .required('Vennligst fyll inn dette feltet.'),
  eMail: yup.string(),
  birthDate: yup
    .object()
    .shape({
      day: yup.number().min(1, 'For lavt').max(31, 'For høyt').required('Dato').typeError('Bruk tall'),
      month: yup.number().min(1, 'For lavt').max(12, 'For høyt').required('Måned').typeError('Bruk tall'),
      year: yup
        .number()
        .min(1753, 'Det var tidlig..')
        .max(new Date().getFullYear(), 'For høyt årstall')
        .required('År')
        .typeError('Bruk tall'),
    })
    .typeError('Vennligst fyll inn dette feltet.'),
});
